/* RESPONSIBLE TEAM: team-ml */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

export class WorkforceTemplateEditorRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(WorkforceTemplateEditorRoute);
